function injectStyle (context) {
  require("!!../../../../ecash/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":false,\"minimize\":true}!../../../../ecash/node_modules/vue-loader/lib/style-compiler/index?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!less-loader?{\"sourceMap\":false}!../../../../ecash/node_modules/vue-loader/lib/selector?type=styles&index=0!./vue-item.vue")
}
/* script */
export * from "!!cache-loader?{\"cacheDirectory\":\"E:\\\\nodeProject\\\\meizu-jr_h5\\\\jr_h5\\\\ecash\\\\node_modules\\\\.cache\\\\cache-loader\"}!babel-loader!../../../../ecash/node_modules/vue-loader/lib/selector?type=script&index=0!./vue-item.vue"
import __vue_script__ from "!!cache-loader?{\"cacheDirectory\":\"E:\\\\nodeProject\\\\meizu-jr_h5\\\\jr_h5\\\\ecash\\\\node_modules\\\\.cache\\\\cache-loader\"}!babel-loader!../../../../ecash/node_modules/vue-loader/lib/selector?type=script&index=0!./vue-item.vue"
/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../../../../ecash/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-186ca4c6\",\"hasScoped\":false,\"optionsId\":\"0\",\"buble\":{\"transforms\":{}}}!../../../../ecash/node_modules/vue-loader/lib/selector?type=template&index=0!./vue-item.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../../ecash/node_modules/vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ../common-npm/flyme7/component/item/vue-item.vue
// module id = null
// module chunks = 